import Vue from 'vue'
import API from '../utils/api'
import env from '../../../config/prod.env.js'

const state = {
  personaldevelopments: { nuevos: [], pendientes: [] },
  personaldevelopment: {}
}

const mutations = {  
  SET_PERSONALDEVELOPMENTS (state, payload) {
    state.personaldevelopments = payload
  },
  SET_PERSONALDEVELOPMENT (state, payload) {
    state.personaldevelopment = payload
  },
  ADD_PERSONALDEVELOPMENT (state, payload) {
    state.personaldevelopments.nuevos.push(payload)
  },
  DELETE_PERSONALDEVELOPMENT (state, payload) {
    state.personaldevelopments.nuevos = state.personalcommitments.nuevos.filter(element => {
      return element._id != payload
    })
  },
  CLOSE_PERSONALDEVELOPMENT (state, payload) {
    state.personaldevelopments.pendientes = state.personalcommitments.pendientes.filter(element => {
      return element._id != payload
    })
  },
  API_FAILURE (state, payload) {
    throw {error: true, payload: payload.body}
  } 
}

const actions = {
  PersonalDevelopmentList: (context, id) => {
    return Vue.http.get(`${env.API}/api/personal-development`)    
      .then((response) => {        
        context.commit('SET_PERSONALDEVELOPMENTS', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  getPDCByIdPlan: (context, data) => {
    const { id, user } = data
    return Vue.http.get(`${env.API}/api/personal-development/by-plan/${id}/${user}`)    
      .then((response) => {        
        context.commit('SET_PERSONALDEVELOPMENTS', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  createPDC: (context, data) => {
    return Vue.http.post(`${env.API}/api/personal-development`, data)    
      .then((response) => {        
        context.commit('SET_PERSONALDEVELOPMENTS', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  getWCById: (context, id) => {
    return Vue.http.get(`${env.API}/api/personal-development/${id}`)    
      .then((response) => {        
        context.commit('SET_PERSONALDEVELOPMENT', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },  
  addCommentToPersonalDevelopment: (context, data) => {
    return Vue.http.post(`${env.API}/api/personal-development/comment`, data)    
      .then((response) => {
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  getCommentsPersonalDevelopment: (context, id) => {
    return Vue.http.get(`${env.API}/api/personal-development/comments/${id}`)
    .then(response => {
        return response.body.message
    })
    .catch(error => {
        return context.commit('API_FAILURE', error)
    })
  },
  close: (context, id) => {
    return Vue.http.delete(`${env.API}/api/personal-development/${id}`)    
      .then((response) => {                
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  deletePersonalDevelopment: (context, id) => {
    return Vue.http.delete(`${env.API}/api/personal-development/remove/${id}`)    
      .then((response) => {      
        context.commit('DELETE_PERSONALDEVELOPMENT', response.body.commitment)       
        return response.body.success
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  closePersonalDevelopment: (context, data) => {
    const { id, accomplished, planid } = data
    return Vue.http.put(`${env.API}/api/personal-development/close/${id}`, { accomplished, planid })
    .then((response) => {      
      return response.body.message
    })
    .catch((error) => {
      console.log(error)
      return context.commit('API_FAILURE', error)
    })
  },
  updateBPersonalDevelopment: (context, data) => {
    return Vue.http.put(`${env.API}/api/personal-development/update/batch/pd`, data)
      .then((response) => {             
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  }
}

const getters = {
  getPersonalDevelopments: (state) => state.personaldevelopments,
  getPersonalDevelopment: (state) => state.personaldevelopment
}

export const personaldevelopment = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/personal_development.js